<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Comissões do {{ profile.name }}</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Administradora</th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody v-show="administrators.length > 0">
                                    <tr 
                                        v-show="iterator.id > 0"
                                        v-for="iterator in administrators" 
                                        :key="iterator.id">
                                        <td>{{ iterator.id }}</td>
                                        <td>{{ iterator.name }}</td>
                                        <td class="td-actions text-right">
                                            <router-link data-original-title v-bind:title="'Comissões da ' + iterator.name" class="btn btn-sm btn-outline-primary" tag="button" :to="{'name': 'profiles.administrators.comissions', params: { 'administrator' : iterator.id, 'id' : $route.params.id }}">
                                                <i class="material-icons">attach_money</i>
                                           </router-link>
                                        </td>
                                   </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        computed: {
            administrators: {
                set(_administrators) {

                },
                get() {
                    return this.$store.state.administrators.itens;
                }
            },
            profile: {
                set(_profile) {

                },
                get() {
                    var self = this;

                    if (this.$store.state.profiles.itens.length > 0) {
                        var profile = this.$store.state.profiles.itens.find(function (_profile) {
                            if (_profile.id == self.$route.params.id) {
                                return _profile;
                            }
                        });
                        return profile;
                    } else {
                        return {
                            name: ""
                        };
                    }
                }
            }
        },
        created: function () {
            if (this.$store.state.profiles.itens.length == 0) {
                this.getData();
            } else if (this.$store.state.administrators.itens.length == 0) {
                this.getDataAdministrators();
            }
        },
        methods: {
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('profiles/all');

                response.then(function () {
                    if (self.$store.state.administrators.itens.length == 0) {
                        self.getDataAdministrators();
                    }
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            async getDataAdministrators() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('administrators/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            }
        }
    };
</script>